import React from 'react';
import {Input, Select, Form, Modal, DatePicker,Upload,message,Button,Icon,Col,Row} from 'antd';
import moment from 'moment';
import {server} from '../../../config/serverConfig';


const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}

const formLargeItemLayout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 19,
  },
}

const modalMaster = ({visible,type,item = {},onOk,onCancel,form: {getFieldDecorator,validateFields,getFieldsValue,
	},}) => {

	function handleOk (fileName) {
		validateFields((err, values) => {
		
		if(err){return }
		
	  //如果是 Select InputNumber 作为输入组件；如果不填返回的是 undefined，应该变成 null
      //if(values.cid == item.cid){delete values.cid; } else {if(typeof(values.cid)=="undefined"){values.cid = null; }}	  

		values.guarantee_contract_url =fileName;	
		
		if (Object.getOwnPropertyNames(values).length == 0) {
		  onCancel()
		  return
		}
	  
	  if(item.id){values.id = item.id} //如果是变更，item有内容，把id给到values

		onOk(values)      

	  })
	}


	const modalOpts = {
	  title: '上传担保合同',
	  visible,
	  onOk: handleOk,	  
	  onCancel,keyboard:false,maskClosable:false,
	  wrapClassName: 'vertical-center-modal',
	  width: 520,
	  //okText: '确认',
      //cancelText: '取消',
	 footer:null
	}

	const props = {
		  name: item.order_no,		 
		  action: server.path + 'fileupload/guContract',		  
		  headers: {
			token: sessionStorage.getItem('token'),
		  },
		  onChange(info) {	
			
			if (info.file.status ==='done') {				 
				  if (info.file.response.status ==true){
					message.success(`${info.file.name} 文件上传成功`);	
					console.log(info.file.response)
					handleOk(info.file.response.msg);	
					
								
				  }else {
					message.error(`${info.file.response.data}`);
				  }
			  
			} else if (info.file.status ==='error'){			
			  message.error(`${info.file.name} file upload failed.`);
			}
		  },
		};	 

	return (
	  <Modal {...modalOpts}>
	  <Upload {...props}>
					<Button><Icon type="upload" /> 点击上传</Button>
			  </Upload>
		
		
	  </Modal>
	)
}


const ModalRender = Form.create()(modalMaster); 


export default ModalRender;
